function TeamOptions() {
  
  const teamOptions = [
    { value: 'Arsenal Football Club', label: 'Arsenal Football Club' },
    { value: 'Aston Villa Football Club', label: 'Aston Villa Football Club' },
    { value: 'Brentford Football Club', label: 'Brentford Football Club' },
    { value: 'Brighton & Hove Football Club', label: 'Brighton & Hove Albion Football Club' },
    { value: 'Burnley Football Club', label: 'Burnley Football Club' },
    { value: 'Chelsea Football Club', label: 'Chelsea Football Club' },
    { value: 'Crystal Palace Football Club', label: 'Crystal Palace Football Club' },
    { value: 'Everton Football Club', label: 'Everton Football Club' },
    { value: 'Leeds United Football Club', label: 'Leeds United Football Club' },
    { value: 'Leicester Football Club', label: 'Leicester City Football Club' },
    { value: 'Liverpool Football Club', label: 'Liverpool Football Club' },
    { value: 'Manchester City Football Club', label: 'Manchester City Football Club' },
    { value: 'Manchester United Football Club', label: 'Manchester United Football Club' },
    { value: 'Newcastle United Football Club', label: 'Newcastle United Football Club' },
    { value: 'Norwich City Football Club', label: 'Norwich City Football Club' },
    { value: 'Southampton Football Club', label: 'Southampton Football Club' },
    { value: 'Tottenham Football Club', label: 'Tottenham Hotspur Football Club' },
    { value: 'Watford Football Club', label: 'Watford Football Club' },
    { value: 'West Ham United Football Club', label: 'West Ham United Football Club' },
    { value: 'Wolverhampton Football Club', label: 'Wolverhampton Football Club' }
  ]
  return teamOptions
}
export default TeamOptions